var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPython(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "dark",
    d: "M8.95 0C4.372 0 4.657 1.985 4.657 1.985l.005 2.056h4.368v.617H2.929S0 4.326 0 8.943c0 4.618 2.556 4.454 2.556 4.454h1.526v-2.142S4 8.699 6.597 8.699h4.332s2.434.039 2.434-2.352V2.393S13.733 0 8.949 0zM6.54 1.383a.785.785 0 1 1 .002 1.57.785.785 0 0 1-.002-1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "light",
    d: "M9.08 17.933c4.576 0 4.29-1.984 4.29-1.984l-.005-2.056H8.998v-.618H15.1s2.929.332 2.929-4.285c0-4.618-2.557-4.454-2.557-4.454h-1.525v2.143s.082 2.556-2.516 2.556H7.1s-2.434-.04-2.434 2.352v3.953s-.37 2.393 4.413 2.393zm2.408-1.382a.785.785 0 1 1-.002-1.57.785.785 0 0 1 .002 1.57z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPython);
export default __webpack_public_path__ + "static/media/python.5e3e7bddac269efd59c92f8af4f9ab6f.svg";
export { ForwardRef as ReactComponent };